import { ENV, VERSION, SENTRY_AUTH_TOKEN } from '@wolffun/env-var';
import * as Sentry from '@sentry/react';
const EVENT_SAMPLE_RATE = 0.02;
const TRACE_SAMPLE_RATE = 0.01;

const initializeSentry = ({
  history
}) => {
  if (ENV !== 'production' || !SENTRY_AUTH_TOKEN) {
    return;
  }

  Sentry.init({
    dsn: 'https://df25582ca9bb4d05a52e3453005121d3@o1066976.ingest.sentry.io/6060930',
    integrations: [new Sentry.BrowserTracing({
      routingInstrumentation: Sentry.reactRouterV5Instrumentation(history)
    })],
    normalizeDepth: 5,
    // increase the default depth so that we can see more of the Redux state.
    tracesSampleRate: TRACE_SAMPLE_RATE,
    environment: ENV,
    release: VERSION,
    ignoreErrors: [// Network errors
    /NetworkError/i, /Network request failed/i, /The network connection was lost./i, /Failed to fetch/i, /Failed to load script /i, /Failed to register a ServiceWorker/i, /Loading chunk (\d+) failed/i, /Loading CSS chunk (\d+) failed/i, /Blocked a frame with origin/i, /from accessing a cross-origin frame. Protocols, domains, and ports must match/i, /socket reconnect error/i, /socket disconnect/i, // Unactionable errors
    /QuotaExceededError/i, /UnknownError/i, /ResizeObserver loop limit exceeded/i, /InvalidStateError/i, /AbortError/i, /out of memory/i, /ConstraintError/i, /chrome-extension/i, //
    // Browser weird errors
    /__gCrWeb/i, /zaloJSV2/i, /vid_mate_check/i, /onScreenResumed/i, /onScreenPaused/i, /WeixinJSBridge/i, /NS_ERROR_NOT_INITIALIZED/i, /mraid/i, /Unauthoried/i, /MoatMAK/i, /jQuery/i, /userscripts/i, /loaderCB01579/i, /NodeFilter/i, /__firefox__/i, /pktAnnotationHighlighter/i, /AFMA_ReceiveMessage/i, /goldlog/i, /ToutiaoJSBridge/i],
    denyUrls: [// Google Adsense
    /pagead\/js/i, // Facebook flakiness
    /graph\.facebook\.com/i, // Facebook blocked
    /connect\.facebook\.net\/en_US\/all\.js/i, // Woopra flakiness
    /eatdifferent\.com\.woopra-ns\.com/i, /static\.woopra\.com\/js\/woopra\.js/i, // Chrome extensions
    /extensions\//i, /^chrome:\/\//i, // Other plugins
    /127\.0\.0\.1:4001\/isrunning/i, // Cacaoweb
    /webappstoolbarba\.texthelp\.com\//i, /metrics\.itunes\.apple\.com\.edgesuite\.net\//i],
    beforeSend: event => {
      const shouldKeepEvent = Math.random() < EVENT_SAMPLE_RATE;

      if (!shouldKeepEvent) {
        return null;
      }

      return event;
    }
  });
};

export default initializeSentry;